import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import pkg from '../package.json'

Vue.use(Router)

const env = process.env.VUE_APP_ENV
const { endpoint, endpointLocal, endpointStaging } = pkg.config

const src =
  env === 'development' && !endpointStaging
    ? endpointLocal
    : env === 'development' || env === 'staging'
    ? endpointStaging
    : endpoint

const home = () => import(/* webpackChunkName: "home" */ './views/Home.vue')

const viewer = () =>
  import(/* webpackChunkName: "viewer" */ './views/Viewer.vue')

const campus = () =>
  import(/* webpackChunkName: "campus" */ './views/Campus.vue')

const content = () =>
  import(/* webpackChunkName: "content" */ './views/Content.vue')

const routes = [
  {
    path: '*',
    redirect: '/ug'
  },
  {
    path: '/',
    name: 'home',
    redirect: '/ug',
    component: home,
    children: [
      {
        path: ':level_id',
        name: 'level'
      }
    ]
  },
  {
    path: '/:level_id/explore-for-yourself',
    name: 'campus',
    meta: { back: 'home', campus: true },
    component: viewer,
    children: [
      {
        path: ':category_id',
        name: 'campus-category',
        meta: { back: 'level', campus: true, categories: true },
        components: {
          campus: campus
        }
      },
      {
        path: ':category_id/media/:media_id',
        name: 'category-media',
        meta: { back: 'campus-category', media: true, campus: true },
        components: {
          campus: campus,
          content: content
        }
      },
      {
        path: ':category_id/location/:location_id/:media_id',
        name: 'location-media',
        meta: {
          back: 'campus-category',
          location: true,
          pager: true,
          media: true,
          sidebar: true
        },
        components: {
          content: content,
          campus: campus
        }
      },
      {
        path: ':category_id/location/:location_id/:media_id/:hotspot_id',
        name: 'location-hotspot',
        meta: {
          back: 'location-media',
          location: true,
          media: true,
          hotspot: true
        },
        components: {
          content: content
        }
      }
    ]
  },
  {
    path: '/:level_id/take-a-guided-tour',
    name: 'guided-tour',
    meta: { back: 'home', guided: true },
    component: viewer,
    children: [
      {
        path: ':tour_id',
        name: 'guided-intro',
        meta: {
          back: 'level',
          tour: true,
          intro: true
        },
        components: {
          content: content
        }
      },
      {
        path: ':tour_id/:media_id',
        name: 'guided-media',
        meta: {
          back: 'guided-intro',
          tour: true,
          pager: true,
          sidebar: true
        },
        components: {
          content: content
        }
      },
      {
        path: ':tour_id/:media_id/:hotspot_id',
        name: 'guided-hotspot',
        meta: {
          back: 'guided-media',
          tour: true,
          media: true,
          hotspot: true
        },
        components: {
          content: content
        }
      }
    ]
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (!store.state.posts.length) {
    Promise.all([
      fetch(`${src}/rv/v1/basis?per_page=-1`).then(res => res.json())
    ])
      .then(([res]) => {
        store.commit({
          type: 'populate',
          posts: res,
          error: null
        })
        store.commit('route', to)
        next()
        store.commit('isLoading', false)
      })
      .catch(err => {
        store.commit({
          type: 'populate',
          error: err
        })
      })
  } else {
    store.commit('isLoading', true)
    store.commit('route', to)
    next()
    store.commit('isLoading', false)
  }
})

export default router
